module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_one_has_written_yet":"まだ誰もこの商品を評価していません。","no_one_who_has_type_has_written_yet_html":"{userPropertyTypeOptionName}タイプの購入者はまだこの商品を評価していません。","should_write_review":"ぜひ最初のレビューを書いてみましょう！","write_review":"レビューを書く"}}')
  delete Component.options._Ctor
}
